import { render } from "./bills_report.vue?vue&type=template&id=bdf2cc0c"
import script from "./bills_report.vue?vue&type=script&lang=js"
export * from "./bills_report.vue?vue&type=script&lang=js"

import "./bills_report.vue?vue&type=style&index=0&id=bdf2cc0c&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__